import { setCancelDiagnosticsStatus } from "./ExecutionStatus";
import { diagnostics } from "./BlobHelper";
import * as Util from "./ErrorHelper";
// String values that indicate which icon should be displayed on each test
export const statusIconVals = {
    success: "success",
    error: "error",
    warning: "warning",
    inProgress: "in-progress",
};
// How far along the tests we are
let percentCompletion = 0;
const global = window;
const { selfHelp: { resources, useTelemetry, runAuthDiagnostics } } = global;
const errorSvg = "<svg class=\"shd-error-summary-icon\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z\" fill=\"#E00B1C\"></path><path d=\"M12.388 4.422L10.966 3L7.694 6.272L4.422 3L3 4.422L6.272 7.694L3 10.966L4.422 12.388L7.694 9.116L10.966 12.388L12.388 10.966L9.116 7.694L12.388 4.422Z\" fill=\"white\"></path></svg>";
const successSvg = "<svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z\" fill=\"#57A300\"></path><path d=\"M3.55311 8.29107C3.47911 8.21207 3.44111 8.10807 3.44511 8.00007C3.44911 7.89107 3.49511 7.79107 3.57511 7.71607L4.41011 6.94407C4.48611 6.87507 4.58311 6.83707 4.68411 6.83707C4.79611 6.83707 4.90411 6.88407 4.98011 6.96607L7.11611 9.25807L10.9231 4.38307C11.0001 4.28407 11.1161 4.22607 11.2421 4.22607C11.3321 4.22607 11.4171 4.25507 11.4891 4.31007L12.3951 5.00907C12.5681 5.13707 12.6051 5.38607 12.4751 5.56307L7.60711 11.7961C7.41811 12.0381 7.05711 12.0541 6.84711 11.8291L3.55311 8.29107Z\" fill=\"white\"></path></svg>";
const warningSvg = "<svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M15.7917 13.92L9.26272 0.771C8.73073 -0.257 7.26772 -0.257 6.73873 0.771L0.208725 13.716C-0.323275 14.744 0.208725 15.978 1.27173 15.978H14.7287C15.7917 16.182 16.3227 14.95 15.7917 13.92Z\" fill=\"#DB7500\"/><path d=\"M7.99978 14.449C8.80004 14.449 9.44878 13.8003 9.44878 13C9.44878 12.1998 8.80004 11.551 7.99978 11.551C7.19952 11.551 6.55078 12.1998 6.55078 13C6.55078 13.8003 7.19952 14.449 7.99978 14.449Z\" fill=\"white\"/><path d=\"M6.6001 4L7.1001 10H8.9001L9.4001 4H6.6001Z\" fill=\"white\"/></svg>";
const accordionChevron = "<svg class='shd-accordion-show-details shd-chevron-show-details' width='12' height='7' viewBox='0 0 12 7' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M6 6.70898L0.146484 0.855469L0.855469 0.146484L6 5.29102L11.1445 0.146484L11.8535 0.855469L6 6.70898Z' fill='#0078D4'></path></svg>";
// Total must equal 100
const testValues = {
    fetchManifest: 10,
    serviceHealthEndpoints: 20,
    clientSideDependencyEndpoints: 30,
    loadIFrame: 10,
    localStorage: 5,
    sessionStorage: 5,
    webWorkers: 10,
    cookiePersistence: 5,
    requestBodyPersistence: 5,
};
// Adjust values so that display progress bar does not grow past 100%
if (runAuthDiagnostics) {
    testValues.authToken = 20;
    testValues.serviceHealthEndpoints = 15;
    testValues.fetchManifest = 5;
    testValues.clientSideDependencyEndpoints = 25;
    testValues.loadIFrame = 5;
}
/**
 * Generates and displays a status icon for each test depending on parameters
 *
 * @param id the ID for the test that needs to have its status icon updatedd
 * @param status accepts four statuses: success, fail, cancel, in-progress
 */
export function displayStatusIcon(id, status) {
    const statusDisplayParent = document.getElementById(`shdid-${id}-icon-display-container`);
    statusDisplayParent.innerHTML = "";
    switch (status) {
        case "success": {
            const successCircle = document.createElement("div");
            successCircle.innerHTML = successSvg;
            statusDisplayParent.appendChild(successCircle);
            break;
        }
        case "error": {
            const errorCircle = document.createElement("div");
            errorCircle.innerHTML = errorSvg;
            statusDisplayParent.appendChild(errorCircle);
            break;
        }
        case "cancel": {
            const cancelCircle = document.createElement("div");
            cancelCircle.innerHTML = warningSvg;
            statusDisplayParent.appendChild(cancelCircle);
            break;
        }
        case "in-progress": {
            const inProgressEl = document.createElement("div");
            inProgressEl.className = "shd-loading-spinner";
            statusDisplayParent.appendChild(inProgressEl);
            break;
        }
        default:
            break;
    }
}
/** Helper function to remove the display:none class styling */
function show(el) {
    el.classList.remove("shd-hide");
}
/** Helper function to add the display:none class styling */
function hide(el) {
    el.classList.add("shd-hide");
}
/** Toggles display for the "Run tasks again" and "download blob" button  */
function togglePostTestButtonView(display) {
    const runTasksBtn = document.getElementById("shdid-run-tasks-btn");
    const blob = document.getElementById("shdid-download-blob-link");
    display ? show(runTasksBtn) : hide(runTasksBtn);
    display ? show(blob) : hide(blob);
}
/** Sets state of parent element so that chevron will rotate according to whether accordion is open or not */
function rotateChevronSVG(element) {
    const expanded = element.getAttribute("aria-expanded");
    expanded === "true" ? element.setAttribute("aria-expanded", "false") : element.setAttribute("aria-expanded", "true");
}
/** Toggles display for blue progress bar at top of the page */
function toggleProgressBarDisplay(display) {
    const bar = document.getElementById("shdid-horizontal-status-bar");
    display ? show(bar) : hide(bar);
}
/** Hides and deletes all accordion display */
function removeAccordionAndData(key) {
    if (key) {
        const content = document.getElementById(`shdid-${key}-accordion-content`);
        if (content) {
            content.innerHTML = "";
        }
        return;
    }
    document.querySelectorAll(".shd-accordion-content").forEach((content) => {
        if (content) {
            content.innerHTML = "";
        }
    });
}
/** Toggles the display of "Show All Details" checkbox */
function toggleMoreDetailsCheckBoxDisplay(display) {
    const showMoreDetailsCheckbox = document.getElementById("shdid-shd-show-details-container");
    display ? show(showMoreDetailsCheckbox) : hide(showMoreDetailsCheckbox);
}
/** Shows the cancel button while tests are being ran */
function toggleCancelButtonDisplay(display) {
    const cancelBtn = document.getElementById("shdid-cancel-tasks-btn");
    display ? show(cancelBtn) : hide(cancelBtn);
}
/** Shows the "_ out of _ tests failed" message summary */
function toggleErrorSummaryDisplay(display) {
    const errorSummaryContainer = document.getElementById("shdid-shd-error-summary");
    display ? show(errorSummaryContainer) : hide(errorSummaryContainer);
}
/** Sets the checkbox to unchecked at beginning of tests */
export function resetCheckbox() {
    const checkbox = document.getElementById("shdid-shd-show-details-checkbox");
    checkbox.checked = false;
}
/** Alters the display when either an individual task is ran or all tests are ran */
function startAnyTestDisplayUpdate() {
    resetCheckbox();
    togglePostTestButtonView(false);
    toggleErrorSummaryDisplay(false);
}
/** Minimizes all accordions, inverts chevrons */
function minimizeAccordions() {
    document.querySelectorAll(".shd-accordion-show-details").forEach((element) => {
        element.setAttribute("aria-expanded", "false");
    });
    document.querySelectorAll(".shd-accordion-content-active").forEach((element) => {
        element.classList.remove("shd-accordion-content-active");
        element.style.maxHeight = "0";
    });
}
/** Initializes the view to a "running" status */
export function startAllTestDisplayUpdate() {
    percentCompletion = 0;
    if (useTelemetry) {
        toggleFeedbackContainer(false);
        toggleFeedbackDisplay(false);
        togglePostFeedbackDisplay(false);
    }
    startAnyTestDisplayUpdate();
    toggleProgressBarDisplay(true);
    toggleMoreDetailsCheckBoxDisplay(true);
    toggleCancelButtonDisplay(true);
    removeAccordionAndData();
    minimizeAccordions();
    togglePostTestDisplay(false);
}
/** Alters the display for when an individual task is ran */
export function startTaskDisplayUpdate(taskId) {
    percentCompletion = percentCompletion - testValues[taskId];
    startAnyTestDisplayUpdate();
    if (useTelemetry) {
        toggleFeedbackContainer(false);
        toggleFeedbackDisplay(false);
        togglePostFeedbackDisplay(false);
    }
    togglePostTestDisplay(false, taskId);
    removeAccordionAndData(taskId);
}
/** Constructs the string "_ out of _ tasks have failed" for error summary display */
function createFailedTestsDisplayStr(errors, tests) {
    const summary = resources.ErrorReport_summary.replace("{0}", errors.toString())
        .replace("{1}", tests.toString());
    return summary;
}
/** Determine how many tests failed for failure summary at top of page */
function calculateFailedTests() {
    let errors = 0;
    let tests = 0;
    // excludes hosting service and browser detection from diagnostics blob
    const values = Object.keys(testValues).map(key => diagnostics[key]);
    values.forEach((value) => {
        tests++;
        if (!value || !value.success) {
            errors++;
        }
    });
    return { errors, tests };
}
/** Updates display for the all task error summary to a failure scenario */
function setErrorContainerRed() {
    const summaryContainer = document.getElementById("shdid-shd-error-summary");
    if (summaryContainer.classList.contains("shd-error-summary-success")) {
        summaryContainer.classList.remove("shd-error-summary-success");
    }
    summaryContainer.classList.add("shd-error-summary-failure");
}
/** Updates display for the all task error summary to a success scenario */
function setErrorContainerGreen() {
    const summaryContainer = document.getElementById("shdid-shd-error-summary");
    if (summaryContainer.classList.contains("shd-error-summary-failure")) {
        summaryContainer.classList.remove("shd-error-summary-failure");
    }
    summaryContainer.classList.add("shd-error-summary-success");
}
/** Will be used to construct the A tag for the "Microsoft Support" string in success scenarios */
function createTestsSucceededHtmlStr() {
    return resources.ErrorReport_summarySuccess.replace("{0}", `${resources.Link_support}`);
}
/** Shows / hides container that holds feedback message */
function toggleFeedbackContainer(display) {
    const feedbackContainer = document.getElementById("shdid-feedback-container");
    display ? show(feedbackContainer) : hide(feedbackContainer);
}
/**
 * Shows / hides "Was this helpful?" feedback links
 *
 * @param display - whether to display the message or not
 */
function toggleFeedbackDisplay(display) {
    const feedbackDisplay = document.getElementById("shdid-feedback-display");
    if (display) {
        togglePostFeedbackDisplay(false);
        show(feedbackDisplay);
    }
    else {
        hide(feedbackDisplay);
    }
}
/**
 * Shows / hides "Thank you for your feedback." message
 *
 * @param display - whether to display the message or not
 */
export function togglePostFeedbackDisplay(display) {
    const postFeedbackDisplay = document.getElementById("shdid-post-feedback-display");
    if (display) {
        show(postFeedbackDisplay);
        toggleFeedbackDisplay(false);
    }
    else {
        hide(postFeedbackDisplay);
    }
}
/** Sets the "_ out of _ tasks failed. Please check the details below." string */
function setErrorSummaryDisplay() {
    const { errors, tests } = calculateFailedTests();
    const summaryText = document.getElementById("shdid-shd-error-summary-text");
    const iconContainer = document.getElementById("shd-error-summary-icon-container");
    if (errors) {
        setErrorContainerRed();
        summaryText.innerText = createFailedTestsDisplayStr(errors, tests);
        iconContainer.innerHTML = errorSvg;
    }
    else {
        setErrorContainerGreen();
        summaryText.innerHTML = createTestsSucceededHtmlStr();
        iconContainer.innerHTML = successSvg;
    }
}
/** Changes the view to a "tests have ended" status */
export function endTestDisplayUpdate() {
    percentCompletion = 100;
    togglePostTestButtonView(true);
    toggleProgressBarDisplay(false);
    setErrorSummaryDisplay();
    toggleCancelButtonDisplay(false);
    toggleErrorSummaryDisplay(true);
    if (useTelemetry) {
        toggleFeedbackContainer(true);
        toggleFeedbackDisplay(true);
        togglePostFeedbackDisplay(false);
    }
}
/**
 * Updates DOM to reflect which tests were cancelled before completion
 *
 * @param {Record<string, string>} diagnostics The object holding all the diagnostic data
 * from each test.
 */
export function handleCancelledTests() {
    Object.keys(diagnostics).forEach((key) => {
        if (!diagnostics[key]) {
            displayStatusIcon(key, "cancel");
            showTestAsCancelled(key);
        }
    });
}
/**
 * Increases blue progress bar width depending which test has completed.
 *
 * @param {string} key The key indicating which test was completed.
 */
export function makeBarGrow(key) {
    const bar = document.getElementById("shdid-blue-status-bar");
    const end = percentCompletion + testValues[key];
    bar.style.setProperty("--end", `${end}%`);
    bar.classList.add("shd-bar-progress");
    percentCompletion = end;
    if (percentCompletion === 100) {
        endTestDisplayUpdate();
        setCancelDiagnosticsStatus(false);
    }
}
/**
 * maps a response to a class which indicates what color the response should render
 *
 * @param {number} status the http status code which needs a color assigned
 * @returns {string} the class name the response should be rendered with
 */
function returnClassForStatusCodes(status) {
    if (Util.isSuccess(status)) {
        return "shd-success-text";
    }
    else if (Util.isError(status)) {
        return "shd-error-text";
    }
    else if (Util.isWarning(status)) {
        return "shd-warning-text";
    }
    else {
        return "";
    }
}
/**
 * Toggles the display of the accordion, dropdown, etc. after a task has finished running
 *
 * @param {boolean} display a boolean representing whether the value should be displayed or not
 * @param {string} key if provided, key references the task for which to display. If not, then toggles display
 * for all tasks.
 */
function togglePostTestDisplay(display, key) {
    if (key) {
        const postTestDisplay = document.getElementById(`shdid-${key}-post-test-display`);
        display ? show(postTestDisplay) : hide(postTestDisplay);
        return;
    }
    document.querySelectorAll(".shd-post-test-display").forEach((el) => {
        display ? el.classList.remove("shd-hide") : el.classList.add("shd-hide");
    });
}
/**
 * Creates text display for accordion expand button
 *
 * @param {string} key - the key for the accordion text we need to update
 */
function createAccordionTextBtnDisplay(key) {
    const checkbox = document.getElementById("shdid-shd-show-details-checkbox");
    const accordionContent = document.getElementById(`shdid-${key}-accordion-content`);
    const displayedResponses = accordionContent.getAttribute("data-default-display-num");
    const totalResponses = accordionContent.getAttribute("data-total-num");
    const showDetailsEl = document.getElementById(`shdid-${key}-acc-show-details-btn`);
    let showDetailsText;
    if ($(checkbox).is(":checked")) {
        // Display errors & successes
        if (accordionContent.classList.contains("shd-accordion-content-active")) {
            showDetailsText = createShowMoreDetailsHtml(resources.Accordion_showAllDetailsExpanded, totalResponses, totalResponses);
        }
        else {
            showDetailsText = createShowMoreDetailsHtml(resources.Accordion_showAllDetails, totalResponses, totalResponses);
        }
    }
    else {
        // Display only errors
        if (accordionContent.classList.contains("shd-accordion-content-active")) {
            showDetailsText = createShowMoreDetailsHtml(resources.Accordion_showSomeDetailsExpanded, displayedResponses, totalResponses);
        }
        else {
            showDetailsText = createShowMoreDetailsHtml(resources.Accordion_showSomeDetails, displayedResponses, totalResponses);
        }
    }
    showDetailsEl.innerHTML = showDetailsText;
}
/**
 * Constructs the display for the Endpoint Responses
 *
 * @param responses - the response data from the server
 * @param key - which diagnostic we are creating the endpoint responses for
 */
function createEndpointDetails(responses, key) {
    if (!Array.isArray(responses)) {
        responses = [responses];
    }
    const detailsContainer = document.createElement("div");
    responses.forEach((response) => {
        const serverMessage = response.statusText || resources.Endpoint_none;
        const greyDetailsBox = document.createElement("div");
        const colorClass = returnClassForStatusCodes(response.status);
        const responseIsError = Util.isError(response.status);
        let responseErrorDetails = "";
        greyDetailsBox.classList.add("shd-more-details-grey-display-box");
        const title = `<span class="${colorClass}">${response.name}</br>${response.uri}</span></br>`;
        const versionInfo = response.version ? `${resources.Endpoint_version}: ${response.version}</br>` : "";
        const status = `${resources.Endpoint_status}: ${response.status}</br>`;
        if (responseIsError) {
            responseErrorDetails = `${resources.Endpoint_serverMessage}: ${serverMessage}`;
            if (response.status === 0) {
                responseErrorDetails += `</br>${resources.Endpoint_statusZeroInfo}`;
            }
        }
        else {
            greyDetailsBox.classList.add("shd-hide-success-responses");
            greyDetailsBox.classList.add("shd-hide");
        }
        greyDetailsBox.innerHTML = `${title}${versionInfo}${status}${responseErrorDetails}`;
        detailsContainer.append(greyDetailsBox);
    });
    if (key === "serviceHealthEndpoints") {
        const greyDetailsBox = document.createElement("div");
        greyDetailsBox.className = "shd-more-details-grey-display-box";
        greyDetailsBox.innerHTML = `<span class="shd-bold">${resources.ServiceHealth_note}:</span> ${resources.ServiceHealth_moreInfo} <a href="https://status.azure.com/">https://status.azure.com/</a>`;
        detailsContainer.append(greyDetailsBox);
    }
    if (key === "clientSideDependencyEndpoints") {
        const greyDetailsBox = document.createElement("div");
        greyDetailsBox.className = "shd-more-details-grey-display-box";
        greyDetailsBox.innerHTML = `<span class="shd-bold">${resources.PortalDependencies_note}:</span> ${resources.PortalDependencies_moreInfo} <a href="https://learn.microsoft.com/azure/azure-portal/azure-portal-safelist-urls">https://learn.microsoft.com/azure/azure-portal/azure-portal-safelist-urls</a>`;
        detailsContainer.append(greyDetailsBox);
    }
    return detailsContainer;
}
/** Prepends chevron to text "Show _ of _ details" */
function createShowMoreDetailsHtml(text, value1, value2) {
    return `${accordionChevron} ${text.replace("{0}", value1).replace("{1}", value2)}`;
}
/**
 * Updates display of individual accordions when either expanded or minimized
 *
 * @param {string} key - the key for which accordion is to be expanded / minimized
 */
export function toggleAccordionDataDisplay(key) {
    const accordionContent = document.getElementById(`shdid-${key}-accordion-content`);
    const checkbox = document.getElementById("shdid-shd-show-details-checkbox");
    const defaultDisplayCount = accordionContent.getAttribute("data-default-display-num");
    const totalCounter = accordionContent.getAttribute("data-total-num");
    const showDetailsEl = document.getElementById(`shdid-${key}-acc-show-details-btn`);
    rotateChevronSVG(showDetailsEl);
    accordionContent.classList.toggle("shd-accordion-content-active");
    if (accordionContent.classList.contains("shd-accordion-content-active")) {
        accordionContent.style.maxHeight = `${accordionContent.scrollHeight}px`;
        // if it is a section where certain elements are hidden and it does contain errors and checkbox is checked
        if (defaultDisplayCount && totalCounter && $(checkbox).is(":checked")) {
            showDetailsEl.innerHTML = createShowMoreDetailsHtml(resources.Accordion_showAllDetailsExpanded, totalCounter, totalCounter);
        }
        else if (defaultDisplayCount && totalCounter && defaultDisplayCount !== "0") {
            showDetailsEl.innerHTML = createShowMoreDetailsHtml(resources.Accordion_showSomeDetailsExpanded, defaultDisplayCount, totalCounter);
        }
        else if (defaultDisplayCount === "0") {
            showDetailsEl.innerHTML = createShowMoreDetailsHtml(resources.Accordion_showAllDetailsExpanded, "1", "1");
        }
    }
    else {
        accordionContent.style.maxHeight = "0";
        showDetailsEl.innerHTML = accordionChevron + resources.Accordion_showDetails;
        if (defaultDisplayCount && totalCounter && $(checkbox).is(":checked")) {
            showDetailsEl.innerHTML = createShowMoreDetailsHtml(resources.Accordion_showAllDetails, totalCounter, totalCounter);
        }
        else if (defaultDisplayCount && totalCounter && defaultDisplayCount !== "0") {
            showDetailsEl.innerHTML = createShowMoreDetailsHtml(resources.Accordion_showSomeDetails, defaultDisplayCount, totalCounter);
        }
        else if (defaultDisplayCount === "0") {
            showDetailsEl.innerHTML = createShowMoreDetailsHtml(resources.Accordion_showAllDetails, "1", "1");
        }
    }
}
/** Updates the accordion display when "show all details" is checked */
export function showAllDetails() {
    // shows success responses
    document.querySelectorAll(".shd-hide-success-responses").forEach((el) => { show(el); });
    // removes "All extensions responded successfully" display
    document.querySelectorAll(".shd-table-no-error-display").forEach(function (el) { hide(el); });
    document.querySelectorAll(".shd-accordion-content").forEach(function (button) {
        const key = button.id.split("-")[1];
        const accordionContent = document.getElementById(`shdid-${key}-accordion-content`);
        const totalCounter = accordionContent.getAttribute("data-total-num");
        const showDetailsDisplayText = document.getElementById(`shdid-${key}-acc-show-details-btn`);
        if (accordionContent.classList.contains("shd-accordion-content-active")) {
            // expands accordion size for success responses
            accordionContent.style.maxHeight = `${accordionContent.scrollHeight}px`;
            showDetailsDisplayText.innerHTML = createShowMoreDetailsHtml(resources.Accordion_showAllDetailsExpanded, totalCounter, totalCounter);
        }
        else {
            showDetailsDisplayText.innerHTML = createShowMoreDetailsHtml(resources.Accordion_showAllDetails, totalCounter, totalCounter);
        }
    });
}
/** Updates the accordion display when "show all details" is unchecked */
export function hideAllDetails() {
    document.querySelectorAll(".shd-hide-success-responses").forEach(function (el) { hide(el); });
    document.querySelectorAll(".shd-table-no-error-display").forEach(function (el) { show(el); });
    document.querySelectorAll(".shd-accordion-content").forEach(function (button) {
        const key = button.id.split("-")[1];
        const accordionContent = document.getElementById(`shdid-${key}-accordion-content`);
        const defaultDisplayCount = accordionContent.getAttribute("data-default-display-num");
        const totalCounter = accordionContent.getAttribute("data-total-num");
        const showDetailsDisplayText = document.getElementById(`shdid-${key}-acc-show-details-btn`);
        if (accordionContent.classList.contains("shd-accordion-content-active")) {
            if (defaultDisplayCount === "0") {
                // No errors, should display the one "All responses were successful" div
                showDetailsDisplayText.innerHTML = createShowMoreDetailsHtml(resources.Accordion_showAllDetailsExpanded, "1", "1");
            }
            else if (totalCounter && defaultDisplayCount) {
                showDetailsDisplayText.innerHTML = createShowMoreDetailsHtml(resources.Accordion_showSomeDetailsExpanded, defaultDisplayCount, totalCounter);
            }
        }
        else {
            if (defaultDisplayCount === "0") {
                // No errors, should display the one "All responses were successful" div
                showDetailsDisplayText.innerHTML = createShowMoreDetailsHtml(resources.Accordion_showAllDetails, "1", "1");
            }
            else if (totalCounter && defaultDisplayCount) {
                showDetailsDisplayText.innerHTML = createShowMoreDetailsHtml(resources.Accordion_showSomeDetails, defaultDisplayCount, totalCounter);
            }
        }
    });
}
/**
 * Creates response display for the endpoint response sections
 *
 * @param {string} key - the table for which we are displaying data
 * @param {EndpointResponse[]} responses - the data to be displayed
 * @param {boolean} containsErrors - indicates whether any errors were found
 * @param {ResponseCount} responseCount - determines the number of errors vs successes
 */
export function createEndpointResponseDisplay(key, responses, containsErrors, responseCount) {
    const { displayedResponses, totalResponses } = responseCount;
    const accordionContent = document.getElementById(`shdid-${key}-accordion-content`);
    accordionContent.classList.add("shd-accordion-content");
    if (!containsErrors) {
        createMoreDetailsSection(key, resources.Results_allSuccessful, "shd-table-no-error-display");
    }
    const table = createEndpointDetails(responses, key);
    accordionContent.setAttribute("data-default-display-num", displayedResponses.toString());
    accordionContent.setAttribute("data-total-num", totalResponses.toString());
    accordionContent.append(table);
    if (containsErrors) {
        createAccordionTextBtnDisplay(key);
    }
    togglePostTestDisplay(true, key);
}
/**
 * Creates the section where the end of test information is displayed
 *
 * @param {string} tableKey the table we need to display information for
 * @param {string} details the details we need to display
 * @param {string} className an optional class name parameter
 */
export function createMoreDetailsSection(tableKey, details, className) {
    const accordionContent = document.getElementById(`shdid-${tableKey}-accordion-content`);
    accordionContent.classList.add("shd-accordion-content");
    const detailsContainer = document.createElement("div");
    if (className) {
        detailsContainer.classList.add(className);
    }
    detailsContainer.classList.add("shd-more-details-grey-display-box");
    accordionContent.setAttribute("data-default-display-num", "1");
    accordionContent.setAttribute("data-total-num", "1");
    detailsContainer.innerHTML = details;
    accordionContent.appendChild(detailsContainer);
    createAccordionTextBtnDisplay(tableKey);
    togglePostTestDisplay(true, tableKey);
}
/**
 * Changes status icon to show the test has been cancelled.
 *
 * @param {string} tableKey The test that needs to be marked as cancelled
 */
export function showTestAsCancelled(tableKey) {
    const accordionContainer = document.getElementById(`shdid-${tableKey}-accordion-content`);
    accordionContainer.setAttribute("data-default-display-num", "1");
    accordionContainer.setAttribute("data-total-num", "1");
    accordionContainer.classList.add("shd-accordion-content");
    const detailsContainer = document.createElement("div");
    detailsContainer.classList.add("shd-more-details-grey-display-box");
    detailsContainer.innerHTML = resources.Results_cancelled;
    accordionContainer.appendChild(detailsContainer);
    togglePostTestDisplay(true, tableKey);
}
//# sourceMappingURL=DomHelper.js.map